import React, { useEffect, useState } from 'react';
import './InstallPrompt.css';

/**
 * InstallPrompt
 * Listens for the browser's `beforeinstallprompt` event and renders a
 * bottom-banner asking the user to install PahadiLingo as a PWA.
 */
export default function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // If already dismissed in this session, don't show again
    if (sessionStorage.getItem('pwa-prompt-dismissed')) return;

    const handler = (e) => {
      e.preventDefault(); // Stop Chrome's mini-infobar
      setDeferredPrompt(e);
      setVisible(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    // Hide if already installed
    window.addEventListener('appinstalled', () => setVisible(false));

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      setVisible(false);
    }
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    sessionStorage.setItem('pwa-prompt-dismissed', '1');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="install-prompt" role="dialog" aria-label="Install PahadiLingo app">
      <div className="install-prompt__icon">
        <img src="/ic_launcher_round.png" alt="PahadiLingo" width={48} height={48} />
      </div>
      <div className="install-prompt__text">
        <strong>Install PahadiLingo</strong>
        <span>Add to your home screen for offline access &amp; faster experience.</span>
      </div>
      <div className="install-prompt__actions">
        <button className="install-prompt__btn install-prompt__btn--install" onClick={handleInstall}>
          Install
        </button>
        <button className="install-prompt__btn install-prompt__btn--dismiss" onClick={handleDismiss} aria-label="Dismiss">
          ✕
        </button>
      </div>
    </div>
  );
}
